import { cn } from '@/utils/utils';
import { LucideIcon } from 'lucide-react';
import { forwardRef } from 'react';

interface ActionDropdownItemProps {
    icon: LucideIcon,
    text: string,
    iconColor?: string,
    onClick?: () => void
}

export const ActionDropdownItem = forwardRef<HTMLDivElement, ActionDropdownItemProps>(({ icon: Icon, text, iconColor, onClick }, ref) => {
    return (
        <div ref={ref} className='px-2 py-1 flex items-center gap-2 cursor-pointer hover:bg-accent hover:text-accent-foreground' onClick={onClick}>
            <Icon className={cn('h-4.5 w-4.5 text-active flex-none', iconColor)} />
            <div className='text-active'>{text}</div>
        </div>
    );
});

ActionDropdownItem.displayName = 'ActionDropdownItem';
